import React, { useEffect } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import cx from "classnames";
import {
  isPushActiveCoach,
  calculateFreeTrialDaysLeft,
  isPullActiveCoach,
} from "../utils/user-helpers";
import Header from "./header";
import { AthleteFinder } from "./header-elements";
import Talk from "talkjs";
import SvgIcon from "./SvgIcon";
import ThemeToggler from "./ThemeToggler";
// THERE IS A LOT OF CODE COMMENTED IN CASE WE NEED TO GO BACK TO THE PREVIOUS BEHAVIOUR
import {
  getPermissionNamesByIds,
  getRoleNameById,
  getUserToRequest,
} from "../views/dashboard/settings/manage-coaches/utils/manage-coaches-utils";
const TALK_JS_APP_ID = "tMXnzHXl";

const MobileNav = ({
  expanded,
  searching,
  title,
  navSections,
  toggleMenu,
  isCoach,
  userCanAccessToPush,
  isPushCoachWithEndedTrial,
  handleAthleteSearch,
  handleNavTitle,
  referAsClients,
  handleContractNav,
  activeUser,
  daysLeft,
  NavItem,
}) => {
  return (
    // Show navbar on top if it is a mobile device user
    <aside role="mobile-nav" className={`${expanded ? "expanded" : ""}`}>
      <div role="nav-header">
        {!searching && (
          <div onClick={() => toggleMenu()}>
            <img src="/img/new-icons/menu.svg" />
          </div>
        )}
        {expanded ? (
          <img />
        ) : !searching ? (
          <div role="nav-header-items">
            <h2>{title}</h2>
            <Header
              mobile
              coachingPortalEnabled={isCoach}
              handleAthleteSearch={handleAthleteSearch}
              handleNavTitle={handleNavTitle}
            />
          </div>
        ) : (
          <AthleteFinder
            referAsClients={referAsClients}
            handleShowFinder={handleAthleteSearch}
            mobile
          />
        )}
      </div>
      <div role="nav-links">
        <ul>
          {navSections.all.map((props, idx) => (
            <NavItem
              key={idx}
              {...props}
              currentTab={title}
              handleNavTitle={handleNavTitle}
              handleContractNav={handleContractNav}
              mobile
            />
          ))}
        </ul>
        {userCanAccessToPush && [
          <span className="mobile-hidden">Subscriptions</span>,
          <ul className="mobile-hidden">
            {navSections.subscriptions.map((props, idy) => (
              <NavItem
                key={idy}
                {...props}
                currentTab={title}
                handleNavTitle={handleNavTitle}
                handleContractNav={handleContractNav}
                mobile
              />
            ))}
          </ul>,
        ]}
        {isCoach && [
          !isPushCoachWithEndedTrial ? (
            <span>Coaching</span>
          ) : (
            <a href="/coach-billing">Upgrade to PULL</a>
          ),
          <ul>
            {navSections.coaching.map((props, idz) => (
              <NavItem
                key={idz}
                {...props}
                validateCoach
                currentTab={title}
                handleNavTitle={handleNavTitle}
                handleContractNav={handleContractNav}
                mobile
              />
            ))}
          </ul>,
          <ul className="mobile-hidden">
            {navSections.msbUniversity.map((props, idz) => (
              <NavItem
                key={idz}
                {...props}
                validateCoach
                currentTab={title}
                handleNavTitle={handleNavTitle}
                handleContractNav={handleContractNav}
                mobile
              />
            ))}
          </ul>,
          <ul>
            <NavItem
              {...navSections.msbUniversity[1]}
              validateCoach
              currentTab={title}
              handleNavTitle={handleNavTitle}
              handleContractNav={handleContractNav}
              mobile
            />
          </ul>,
        ]}

        {isCoach && activeUser.coachingFreeTrial && daysLeft > 0 && (
          <div>
            <a href="/coach-billing" role="button" data-button-type="secondary">
              Free trial: {daysLeft} days left.{" "}
              <span className="clipped font-semibold">Upgrade Now</span>
            </a>
          </div>
        )}
      </div>
    </aside>
  );
};

class Leftbar extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      expanded: false,
      viewportWidth: null,
      title: "",
      searching: false,
      chatSession: null,
      unreadChatConversations: [],
      unreadCommunityChatConversations: [],
    };
    this.lastNotificationTimestamp = null;
    this.toggleMenu = this.toggleMenu.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
    this.handleNavTitle = this.handleNavTitle.bind(this);
    this.handleContractNav = this.handleContractNav.bind(this);
    this.handleOpenNav = this.handleOpenNav.bind(this);
    this.handleAthleteSearch = this.handleAthleteSearch.bind(this);
    this.handleDashboardPaddings = this.handleDashboardPaddings.bind(this);
    this.instanceChat = this.instanceChat.bind(this);
    this.onChangeUnreadMessages = this.onChangeUnreadMessages.bind(this);
    this.handleNewMessageNotification =
      this.handleNewMessageNotification.bind(this);
  }

  toggleMenu() {
    this.setState(
      { expanded: !this.state.expanded },
      this.handleDashboardPaddings
    );
  }

  handleDashboardPaddings() {
    // Adjust Padding for header Wrapper
    const nav = document.querySelector('header[role="main"]');
    if (nav && this.state.viewportWidth > 960)
      nav.style.margin = !this.state.expanded
        ? "0px 0px 0px 4rem"
        : "0px 0px 0px 15rem";
  }

  updateDimensions() {
    this.setState(
      (prevState) =>
        Object.assign({}, prevState, {
          viewportWidth: window.innerWidth,
        }),
      this.handleDashboardPaddings
    );
  }

  handleContractNav() {
    this.setState((prevState) =>
      Object.assign({}, prevState, {
        expanded: false,
      })
    );
  }
  handleOpenNav() {
    this.setState((prevState) =>
      Object.assign({}, prevState, {
        expanded: true,
      })
    );
  }
  handleNavTitle(title) {
    this.setState((prevState) =>
      Object.assign({}, prevState, {
        title,
      })
    );
  }

  handleAthleteSearch() {
    this.setState((prevState) =>
      Object.assign({}, prevState, {
        searching: !prevState.searching,
      })
    );
  }

  instanceChat() {
    const user = this.context.locals.activeUser;
    const { chatSession = null } = this.state;
    if (process.browser && user.chatEnabled && !chatSession) {
      Talk.ready.then(async () => {
        const userChat = await new Talk.User({
          id: user._id,
          name: user.name,
          role: "msbdarktheme",
        });
        const talkJSSession = await new Talk.Session({
          appId: TALK_JS_APP_ID,
          me: userChat,
        });
        if (talkJSSession) {
          this.setState({
            ...this.state,
            chatSession: talkJSSession,
          });
          talkJSSession
            .setDesktopNotificationEnabled(false, { alertOnFailure: false })
            .then(() => {
              console.log("TalkJS notifications are disabled");
            })
            .catch((error) => {
              console.error("Error disabling desktop notifications:", error);
            });
          talkJSSession.unreads.onChange((unreadConversations) => {
            this.onChangeUnreadMessages(unreadConversations, String(user._id));
          });
          if (Notification.permission === "default") {
            Notification.requestPermission()
              .then((permission) => {
                if (permission === "granted") {
                  console.info(
                    "the desktop notifications permission is enabled"
                  );
                } else {
                  console.warn(
                    "the desktop notifications permission has been denied"
                  );
                }
              })
              .catch((error) => {
                console.error("Error enabling desktop notifications:", error);
              });
          }
        }
      });
    }
  }

  /**
   * Update the badge of the message icon only if the messages aren't push
   * @param {*} unreadConversations
   */
  onChangeUnreadMessages(unreadConversations, userInSession) {
    //Update the unreadChatConversations and unreadCommunityChatConversations state depends on the condition
    const updateUnreadState = (filterCondition, stateKey) => {
      const previousStateLength = this.state[stateKey].length;
      const filteredMessages = unreadConversations?.filter(filterCondition);
      const filteredLength = filteredMessages?.length;

      if (
        (filteredLength === 0 && previousStateLength > 0) ||
        (previousStateLength === 0 && filteredLength > 0)
      ) {
        this.setState({
          ...this.state,
          [stateKey]: filteredMessages,
        });
      }
    };
    //we are updating the chat state (the messages that doesn't have the isPush property )
    updateUnreadState(
      (conv) => !conv?.conversation?.custom?.isPush,
      "unreadChatConversations"
    );
    //we are updating the community chat state (the messages that does have the isPush property )

    updateUnreadState(
      (conv) => conv?.conversation?.custom?.isPush,
      "unreadCommunityChatConversations"
    );
    //show the web notification everytime there is a new talkjs message
    if (
      Notification.permission === "granted" &&
      unreadConversations.length > 0
    ) {
      this.handleNewMessageNotification(unreadConversations, userInSession);
    }
  }

  /**
   * Function to display the web notifications
   * @param {*} unreadConversations
   * @param {*} userInSession
   */
  handleNewMessageNotification(unreadConversations, userInSession) {
    // Find the most recent message by timestamp
    const newMessage = unreadConversations?.reduce((latest, current) => {
      return current.lastMessage.timestamp > latest.lastMessage.timestamp
        ? current
        : latest;
    }, unreadConversations[0]); // Start with the first conversation
    const {
      lastMessage: {
        body,
        isByMe,
        timestamp,
        type,
        conversation: { subject, custom },
        sender: { name: senderName },
      },
    } = newMessage;
    //we are checking if the user is muted in that conversation
    const { muted } = custom;
    const parsedMuted = muted ? JSON.parse(muted) : [];
    const isMuted = parsedMuted.includes(userInSession);
    const currentTime = Date.now(); //actual time in ms
    // Check if the message was sent within the last 2 minutes
    const oneMinutesInMs = 1 * 60 * 1000;
    const isRecentMessage = currentTime - timestamp <= oneMinutesInMs;
    /** The webhook is firing an event if the user sends or reads a message, and we don't want to display a notification if the user
      read a message, so, we are storing the time of the last notifification displayed in the lastNotificationTimestamp state, to compare it 
      here with the last message received, if lastNotificationTimestamp doesn't exists, is because it is the first notification displayed,
      and if it exists we are comparing that time with the last message time, if the last message time is bigger that means 
      it is a new message event, if not, it is a read message event 
      */
    const isNewMessageEvent =
      !this.lastNotificationTimestamp ||
      timestamp > this.lastNotificationTimestamp;
    //Send the notification if the event is "new message" type, the message wasn't send by the user in session, is text, is recent
    //and the user isn't muted from that conversation
    if (
      isNewMessageEvent &&
      !isByMe &&
      type === "text" &&
      isRecentMessage &&
      !isMuted
    ) {
      const notificationBody = subject
        ? `${senderName} sent a new message to the group "${subject}"`
        : senderName;
      new Notification(notificationBody, {
        body: body || "You have a new message",
      });
      this.lastNotificationTimestamp = timestamp;
    }
  }

  componentDidMount() {
    const { pathname } = this.context.locals;
    this.instanceChat();

    !this.state.viewportWidth
      ? this.setState((prevState) =>
          Object.assign({}, prevState, {
            viewportWidth: window.innerWidth,
          })
        )
      : null;

    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    const { chatSession = null } = this.state;
    chatSession?.destroy();
    window.removeEventListener("resize", this.updateDimensions);
  }

  render() {
    const {
      pathname,
      query,
      activeUser,
      organizationOwner,
      organizationPermissions: globalOrganizationPermissions = [],
      organizationRoles = [],
    } = this.context.locals;
    const userIsCoach = activeUser.permissions.includes("coach");
    const userToRequest = userIsCoach
      ? getUserToRequest(activeUser, organizationOwner)
      : activeUser;
    const isCoach = _.get(activeUser, "permissions", []).indexOf("coach") > -1;
    const organizationCoach = query.organizationCoach || undefined;

    const {
      organizationPermissions = [],
      organizationId,
      referAsClients,
    } = activeUser;

    const {
      pushAccountInfo: isFe,
      pressAccountInfo,
      coachingBilling,
    } = userToRequest;

    //Get the name of the organization's role of the current user
    const roleName = !!activeUser.organizationRoleId
      ? getRoleNameById(organizationRoles, activeUser.organizationRoleId)
      : "Owner";

    //User's permissions (if it's part of an organization, if not, we only are giving a empty array)
    const userOrganizationPermission =
      organizationPermissions.length > 0
        ? getPermissionNamesByIds(
            globalOrganizationPermissions,
            organizationPermissions
          )
        : [""];

    //Constants to detect the user permissions, if the user not belongs to an organization, is able to see the option, and if it's part of an organization
    //We have to check if the user have the permissions
    const userOrganizationCanAccessToWidgets =
      !organizationId ||
      (!!organizationId && userOrganizationPermission.includes("Widgets"));

    const userOrganizationCanAccessToWorkflows =
      !organizationId ||
      (!!organizationId &&
        userOrganizationPermission.includes("Custom Workflows"));

    const userOrganizationCanAccessToExerciseLibrary =
      !organizationId ||
      (!!organizationId &&
        userOrganizationPermission.includes("Exercise Library"));

    const userCanAccessToPush =
      (!organizationId && isFe) ||
      (isFe && !!organizationId && userOrganizationPermission.includes("PUSH"));

    const userOrganizationCanAccessToTemplates =
      !organizationId ||
      (!!organizationId && userOrganizationPermission.includes("Templates"));
    const userCanAccessToPress =
      (!organizationId && !!pressAccountInfo) ||
      (isFe &&
        !!organizationId &&
        userOrganizationPermission.includes("PRESS"));
    const isAdminOrOwner = roleName === "Owner" || roleName === "Admin";
    const isGym = !!pressAccountInfo && userCanAccessToPress;
    const isPastDue = coachingBilling?.status === "past_due";

    const NavItem = ({
      item = "",
      link = "#",
      trigger = "",
      icon,
      iconLight,
      validateCoach = false,
      validateOnlyPushCoach = false,
      validateIsPush = false,
      comingSoon = false,
      handleNavTitle = () => {},
      handleContractNav = () => {},
      currentTab = "",
      mobile = false,
      warning,
    }) => {
      const valid = validateCoach
        ? isPushActiveCoach(userToRequest)
        : validateOnlyPushCoach
        ? isPushCoachWithEndedTrial || isPushActiveCoach(userToRequest)
        : validateIsPush
        ? userCanAccessToPush
        : true;
      const find =
        !(typeof trigger === "string") &&
        !!trigger.find((link) => _.startsWith(pathname, `${link}`));

      useEffect(() => {
        if (mobile)
          find || _.startsWith(pathname, `${trigger}`)
            ? currentTab !== item && handleNavTitle(item)
            : _.startsWith(pathname, `/coaching-portal/settings`) &&
              currentTab !== "Settings" &&
              handleNavTitle("Settings");
      }, []);
      return (
        <li
          onClick={handleContractNav}
          aria-current={
            find
              ? true
              : _.startsWith(pathname, `${trigger}`)
              ? true
              : undefined
          }
          {...([
            "Subscriber list",
            "Client overview",
            "Athlete overview",
            "Task list",
            "Income",
            "Store",
            "Plan manager",
            "MSB University",
          ].includes(item) && { className: "mobile-hidden" })} // hide these options on mobile cause they are not yet responsive
          data-disabled={!valid}
          data-warning={warning}
        >
          <a
            href={valid && !comingSoon ? link : "#"}
            onClick={(e) => {
              if (!valid) e.preventDefault();
            }}
            aria-disabled={!valid}
          >
            {icon && (
              <div>
                <SvgIcon
                  src={`/img/new-icons/${icon}.svg`}
                  noFilterOnLight={
                    find
                      ? true
                      : _.startsWith(pathname, `${trigger}`)
                      ? true
                      : undefined
                  }
                />
              </div>
            )}
            <span>{item}</span>
          </a>
          {/* init of badge on chat */}
          {item === "Chat" &&
            renderBadge(item, this.state.unreadChatConversations)}
          {item === "Community Chat" &&
            renderBadge(item, this.state.unreadCommunityChatConversations)}
          {/* end of badge on chat */}
        </li>
      );
    };

    const navSections = {
      all: [
        {
          item: "Exercise library",
          link: "/coaching-portal/exercise-library",
          trigger: "/coaching-portal/exercise-library",
          icon: "layer-group",
          iconLight: "layer-group-light",
        },
        {
          item: "Templates",
          link: "/coaching-portal/all-templates?owner=coach",
          trigger: [
            "/coaching-portal/all-templates",
            "/coaching-portal/templates",
          ],
          icon: "dumbbell",
          iconLight: "dumbbell-light",
        },
        {
          item: "Widgets",
          link: "/coaching-portal/widgets",
          trigger: "/coaching-portal/widgets",
          icon: "widgets",
          iconLight: "widgets-light",
        },
      ],
      subscriptions: [
        {
          item: "Store",
          link: "/coaching-portal/store",
          trigger: "/coaching-portal/store",
          icon: "shopping-bag",
          iconLight: "shopping-bag-light",
        },
        {
          item: "Subscriber list",
          link: "/coaching-portal/subscribers",
          trigger: "/coaching-portal/subscribers",
          icon: "list-ul",
          iconLight: "list-ul-light",
          comingSoon: false,
        },
        {
          item: "Income",
          link: "/coaching-portal/income",
          trigger: "/coaching-portal/income",
          icon: "income",
          iconLight: "income-light",
        },
        {
          item: "Community Chat",
          link: "/coaching-portal/community-chat",
          trigger: "/coaching-portal/community-chat",
          icon: "community-chat",
          iconLight: "community-chat-light",
        },
      ],
      coaching: [
        {
          item: referAsClients ? "Client overview" : "Athlete overview",
          link: "/coaching-portal/coaching-dashboard?metric=workouts",
          trigger: "/coaching-portal/coaching-dashboard",
          icon: "clipboard-notes",
          iconLight: "clipboard-notes-light",
        },
        {
          item: referAsClients ? "Client list" : "Athlete list",
          // link: "/coaching-portal/athletes/filtersGroup=all",
          link: `/coaching-portal/athletes?${encodeURIComponent(
            "filters[status.inactive]"
          )}=${encodeURIComponent("false")}&filterGroup=all${
            isPastDue ? "&modal[type]=pending-invoice" : ""
          }`,
          trigger: ["/coaching-portal/athletes", "/athlete-portal/"],
          icon: "user-circle",
          iconLight: "user-circle-light",
        },
        {
          item: "Task list",
          link: "/coaching-portal/tasks?tab=programming",
          trigger: "/coaching-portal/tasks",
          icon: "check-circle",
          iconLight: "check-circle-light",
        },
        {
          item: "Chat",
          link: "/coaching-portal/chat",
          trigger: "/coaching-portal/chat",
          icon: "chat",
          iconLight: "chat-light",
        },
      ],
      gym: [
        {
          item: "Membership list",
          link: "/coaching-portal/memberships",
          trigger: "/coaching-portal/memberships",
          icon: "list-ul",
          iconStyle: {
            height: "12px",
          },
        },
      ],
      msbUniversity: [
        {
          item: "MSB University",
          link: "/coaching-portal/msb-university",
          trigger: "/coaching-portal/msb-university",
          icon: "university",
          iconLight: "university-light",
        },
        {
          item: "MSB Services",
          link: "/coaching-portal/services",
          trigger: "/coaching-portal/services",
          icon: "shop",
        },
      ],
    };

    if (userCanAccessToPush && isAdminOrOwner) {
      navSections.all.push({
        item: "Plan manager",
        link: "/coaching-portal/plan-manager",
        trigger: "/coaching-portal/plan-manager",
        icon: "folder-open",
      });
    }
    if (isAdminOrOwner || userOrganizationCanAccessToWorkflows) {
      navSections.all.push({
        item: "Custom workflows",
        link: "/coaching-portal/custom-workflows",
        trigger: "/coaching-portal/custom-workflows",
        icon: "custom-workflows",
      });
    }

    //hide or show the options if user has access/permissions to the functionalities
    if (!userOrganizationCanAccessToWidgets) {
      const filteredAll = navSections.all.filter(
        ({ item }) => item !== "Widgets"
      );
      navSections.all = filteredAll;
    }
    if (!userOrganizationCanAccessToExerciseLibrary) {
      const filteredAll = navSections.all.filter(
        ({ item }) => item !== "Exercise library"
      );
      navSections.all = filteredAll;
    }

    if (!userOrganizationCanAccessToTemplates) {
      const filteredAll = navSections.all.filter(
        ({ item }) => item !== "Templates"
      );
      navSections.all = filteredAll;
    }

    if (!isAdminOrOwner) {
      const filteredAll = navSections.subscriptions.filter(
        ({ item }) => item !== "Income"
      );
      navSections.subscriptions = filteredAll;
    }

    const daysLeft = calculateFreeTrialDaysLeft(userToRequest);
    const isPushCoachWithEndedTrial =
      userToRequest.permissions.includes("coach") &&
      userToRequest.pushAccountInfo &&
      daysLeft < 1 &&
      !isPullActiveCoach(userToRequest);

    // Show navbar on left if it is a desktop browser user

    const DesktopNav = () => {
      const isInSubscribersListSideDrover =
        (pathname.includes("coaching-portal/subscribers") ||
          pathname.includes("coaching-portal/memberships")) &&
        query.customer
          ? true
          : false;

      return (
        <aside
          role="main"
          open={this.state.expanded ? true : undefined}
          className={isInSubscribersListSideDrover ? "hide-leftbar" : ""}
        >
          <SvgIcon
            src={"/img/new-icons/arrow-square-right.svg"}
            onClickFn={() => this.toggleMenu()}
            classNames={this.state.expanded ? "expanded" : ""}
            id="handle-menu"
          />
          <div>
            <div className="msb-logo"></div>
          </div>
          <ul>
            {navSections.all.map((props, idx) => (
              <NavItem key={idx} {...props} />
            ))}
          </ul>
          {userCanAccessToPush && (
            <ul>
              <div style={{ opacity: this.state.expanded ? "0.7" : 0 }}>
                Subscriptions
              </div>
              {/* {this.state.expanded ? <div>Subscriptions</div> : null} */}
              {navSections.subscriptions.map((props, idy) => (
                <NavItem key={idy} {...props} />
              ))}
            </ul>
          )}
          {isCoach && (
            <>
              <ul>
                {!isPushCoachWithEndedTrial && (
                  <div style={{ opacity: this.state.expanded ? "0.7" : 0 }}>
                    Coaching
                  </div>
                )}
                {isPushCoachWithEndedTrial ? (
                  <a
                    role="button"
                    data-button-type="outline"
                    href="/coach-billing"
                  >
                    Upgrade to PULL
                  </a>
                ) : null}
                {isPastDue ? (
                  <NavItem
                    link="/coaching-portal/athletes?modal[type]=pending-invoice"
                    icon="exclamation-hexagon"
                    item="Pending Payment"
                    warning
                  />
                ) : null}
                {navSections.coaching.map((props, idz) => (
                  <NavItem key={idz} {...props} validateCoach />
                ))}
              </ul>

              {isGym && (
                <ul className="Nav-List">
                  <div style={{ opacity: this.state.expanded ? "0.7" : 0 }}>
                    Gym
                  </div>
                  {navSections.gym.map((props, idy) => (
                    <NavItem key={idy} {...props} />
                  ))}
                </ul>
              )}
              <ul
                className="Nav-List"
                style={{
                  borderBottom: "none",
                }}
              >
                {navSections.msbUniversity.map((props, idz) => (
                  <NavItem key={idz} {...props} validateOnlyPushCoach />
                ))}
              </ul>
              {!userCanAccessToPush && isAdminOrOwner ? (
                <ul className="Nav-List request-push-access">
                  <div>Sell subscriptions with PUSH</div>
                  <li>
                    <a
                      href="https://form.typeform.com/to/jOPku6ra"
                      target="_blank"
                      rel="noopener noreferrer"
                      data-mode="popup"
                      role="button"
                      data-button-type="outline"
                    >
                      <span>Request Access to PUSH</span>
                    </a>
                  </li>
                  {navSections.subscriptions.map((props, idy) => (
                    <NavItem key={idy} {...props} validateIsPush />
                  ))}
                </ul>
              ) : null}
            </>
          )}
          <footer>
            <div>
              <a
                role="button"
                data-button-type="secondary"
                href="https://form.typeform.com/to/Dl4pAwN2"
                target="_blank"
              >
                <SvgIcon src={`/img/new-icons/Bug.svg`} />
                <span>Report Bug</span>
              </a>
            </div>
            <div className="theme-container">
              <ThemeToggler expanded={this.state.expanded} />
            </div>
          </footer>
        </aside>
      );
    };

    return (
      <>
        <MobileNav
          expanded={this.state.expanded}
          searching={this.state.searching}
          title={this.state.title}
          toggleMenu={this.toggleMenu}
          navSections={navSections}
          isCoach={isCoach}
          userCanAccessToPush={userCanAccessToPush}
          isPushCoachWithEndedTrial={isPushCoachWithEndedTrial}
          handleAthleteSearch={this.handleAthleteSearch}
          handleNavTitle={this.handleNavTitle}
          referAsClients={referAsClients}
          handleContractNav={this.handleContractNav}
          activeUser={activeUser}
          daysLeft={daysLeft}
          NavItem={NavItem}
        />
        <DesktopNav />
      </>
    );
  }
}

Leftbar.contextTypes = { locals: PropTypes.object };

export default Leftbar;

const renderBadge = (item, unreadConversations) => {
  return (
    unreadConversations.length > 0 && (
      <div className="badge-unread-notification"></div>
    )
  );
};
